import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <section className="page">
      <h1>Not found</h1>
      <p className="muted">
        That page doesn&apos;t exist. <Link to="/">Back to slate</Link>.
      </p>
    </section>
  );
}
